module.exports = __webpack_public_path__ + "media/images/front/varieties/SANGUINELLI-c0743ed95aef0657ce1e586427b4e66d.jpg";